// export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
export const BASE_URL = process.env.REACT_APP_API_URL || 'https://web-it-prd-soc-billing-weu-001-e5gfhub4dph5gdhs.westeurope-01.azurewebsites.net';